import { render, staticRenderFns } from "./Service19Table.vue?vue&type=template&id=f2016642&"
import script from "./Service19Table.vue?vue&type=script&lang=js&"
export * from "./Service19Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports